<template>
  <div v-if="hasData" class="summary-panel">
    <div class="summary-grid">
      <div v-for="key in displayKeys" :key="key" class="summary-item">
        <label>{{ formatLabel(key) }}:</label>
        <span>{{ formatValue(summary[key]) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SummaryPanel',
  props: {
    summary: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    displayKeys() {
      if (!this.summary) return []
      return Object.keys(this.summary).filter(key => {
        const val = this.summary[key]
        // Hide null, undefined, empty arrays
        if (val === null || val === undefined) return false
        if (Array.isArray(val) && val.length === 0) return false
        return true
      })
    },
    hasData() {
      return this.displayKeys.length > 0
    }
  },
  methods: {
    formatLabel(key) {
      return key
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, str => str.toUpperCase())
        .trim()
    },
    formatValue(value) {
      if (value === null || value === undefined) return '-'
      if (Array.isArray(value)) return value.join(', ')
      if (typeof value === 'object') return JSON.stringify(value)
      if (typeof value === 'number') {
        // Format very large or very small numbers
        if (Math.abs(value) > 1e15 || (value !== 0 && Math.abs(value) < 1e-6)) {
          return value.toExponential(4)
        }
        // Round to reasonable precision
        return Number.isInteger(value) ? value : parseFloat(value.toFixed(6))
      }
      return value
    }
  }
}
</script>

<style scoped lang="scss">
.summary-panel {
  margin-top: 0;
  padding-top: 14px;
  border-top: 1px solid var(--border);

  .summary-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 10px 24px;

    .summary-item {
      display: flex;
      align-items: baseline;
      gap: 7px;

      label {
        font-weight: 600;
        margin: 0;
        color: var(--text2);
        font-size: 11px;
        letter-spacing: 0.02em;
        text-transform: uppercase;
      }

      span {
        color: var(--text);
        font-size: 14px;
        font-weight: 600;
      }
    }
  }
}
</style>
